<template>
    <BasePage>
        <div class="container">
            <div class="card mt-6 mb-7 py-6 px-3 text-center" data-testid="not-found">
                <h1 class="h2">We couldn't find that page</h1>
                <p>The link may be out of date, or the address may have been mistyped.</p>
                <div><router-link class="btn btn-primary" to="/">Back to the home page</router-link></div>
            </div>
        </div>
    </BasePage>
</template>

<script>
import BasePage from '@/components/BasePage.vue';

export default {
    name: 'NotFoundPage',
    components: {
        BasePage,
    },
};
</script>
